import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const ExcelDownload = ({ headers, rows, filename = 'download.xlsx' }) => {
  // Function to safely access nested properties
  const getNestedValue = (row, key) => {
    const keys = key.split('.');
    let value = row;
    for (const k of keys) {
      value = value?.[k]; // Safely access nested property
      if (value === undefined || value === '' || value === null) {
        return 'Not Available';
      }
    }
    return value?.toString() || 'Not Available';
  };

  // Function to convert data and trigger download
  const handleDownload = () => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Add Serial No. column to headers
    const extendedHeaders = [{ label: 'S.No.', key: 'sno' }, ...headers];

    // Prepare the header and rows
    const ws_data = [
      extendedHeaders.map((header) => header.label), // Add headers
      ...rows.map((row, index) =>
        extendedHeaders.map((header) =>
          header.key === 'sno' ? (index + 1).toString() : getNestedValue(row, header.key)
        )
      ),
    ];

    const ws = XLSX.utils.aoa_to_sheet(ws_data);

    // Append the sheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Generate Excel file as an array
    const excelFile = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Trigger the download automatically after file generation
    saveAs(new Blob([excelFile]), filename);
  };

  handleDownload();

  return null; // No UI needed since the download is triggered automatically
};

export default ExcelDownload;
